module.exports = __webpack_public_path__ + "img/gitlab-logo-500.36814e9f.svg";